import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { TeamsSection } from '../../../features/settings/teams-section'

export const Route = createFileRoute('/_app/settings/teams')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'teams'),
  component: TeamsSection,
})
